'use strict';

import 'scrollTo';

import Loader from '../../../_modules/loader/loader';

import {isFieldEmpty, isValidEmail, debounce, displayErrors, delay, adjustFooterOnWindowResize} from './_helper';
import { toaster } from './_material';

let $selectInstitute = $('.select-institute'),
    $searchInstitute = $selectInstitute.find('.search input[type="text"]'),
    $selectedInstitutionFields = $('.select-institute__fields'),
    $searchWrapper = $('.select-institute__search'),
    $institutionEmail = $('#InstituteEmailAddress'),
    $instituteRole = $('#InstituteRole'),
    $phoneNumber = $('#PhoneNumber'),
    $hcpType = $('.HcpType'),
    $hcpId = $('#hcpId'),
    $frmEnrollInstitute = $('.form--enroll-institute'),
    $btnAddInstitution = $('.js-add-institution'),
    $ctaWrapper = $selectInstitute.find('.cta--wrapper'),
    $notFoundMessage = $ctaWrapper.find('p'),
    institutionName = '',
    institutionId = '',
    isAnim = false,
    isRegisterPage = $('.register__page').length,
    obj = {},
    dataParams = {},
    _data = [],
    _filteredData = [],
    _isInvalid = [],
    _selectedInsId = [],
    searchVal = '',
    searchSuggestionHtml = '',
    searchSuggestionTmp = '',
    $antiForgeryId = $selectInstitute.find('input[name=__RequestVerificationToken]'),
    $activeSearchInput; //needed for those pages where there is more than one input.Quick fix given the current codebase

$(() => {

    //TODO consider reviewing this conditions

    if (!$selectInstitute.length) {
        return false;
    }


    // Put Loader in a variable
    let loader = new Loader();

    // render doT template only if needed
    if($('#search-suggestion-tmp').length)
        searchSuggestionTmp = doT.template($('#search-suggestion-tmp').html());


    /* Retrieve list of institution on keyup
    ** Hide previous results on change if input is empty
    */
    $searchInstitute.on('keyup', function (e) {

        let $this = $(this);

        $activeSearchInput = $this;

        delay( "check date", function(){

            $('.not-found').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            searchVal = $this.val();
            getSeachResults();

        } ,600);

    }).on('blur', function (e) {
        if ($(this).val() == '') {

            $ctaWrapper.slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            $('.not-found').hide();

           searchVal = '';
           populateSuggestions();

           // hide fields if institution is not selected
           if(!isRegisterPage){
                $selectedInstitutionFields.slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
           }
        }
    });


    /* Display additional fields if selecting one of the suggested institutions.
    ** If registration page: markup is cloned and multiple institutions can be added */
    $('body').on('click', '.js-select-item', function () {

        if ($('.global-search__item').length) return;

        let $this = $(this);

        institutionName = $this.data('name');
        institutionId = $this.data('id');

        searchVal = '';

        if (isRegisterPage) {
            $searchWrapper
                .hide()
                .find('#SearchInstitute')
                .val('');

            clone();

            _selectedInsId.push(institutionId);

            $('.not-found').hide();

            $ctaWrapper.slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        } else {

            $ctaWrapper.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            $('.not-found').hide();
           
            $activeSearchInput
            .attr('data-institution-id', institutionId)
            .val(institutionName);

            let $currentForm = $activeSearchInput.closest('form'),
                $currentInsId = $currentForm.find('input[name="InstitutionId"]');

            $currentInsId.val(institutionId);

        }

        populateSuggestions();

        $selectedInstitutionFields.slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        $btnAddInstitution.slideDown({
            duration: 100,
            easing: 'easeOutExpo',
            queue: false
        });
    });

    /* Same button is used for two different functionalities
    ** 1) if Institution is not listed: clear previous suggestions
    ** 2) if Continue: make API call */
    $('.js-continue').on('click', function (e) {
        e.preventDefault();

        // Define where to display ajax errors
        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

        let $this = $(this);

        var phoneRegEx = /^[0-9]{8,10}$/;

        _isInvalid = [];

        // if (isInstituteSelected) {
            if (isFieldEmpty($institutionEmail) || !isValidEmail($institutionEmail.val())) {
                $institutionEmail
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($hcpType)) {
                $hcpType
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (!isFieldEmpty($phoneNumber) && !$phoneNumber.val().match(phoneRegEx)) {
                $phoneNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (_isInvalid.length > 0) {
                isAnim = true;
                $this.addClass('error');
                return false;
            } else {

                dataParams = {
                    'HcpId':$hcpId.val(),
                    'InstitutionToEnroll':
                    {
                        'InstitutionId': $searchInstitute.attr('data-institution-id'),
                        'EmailAddress': $institutionEmail.val(),
                        'Role': $('#HcpType').val(),
                        'EmployeeId': $('#EmployeeId').val(),
                        'PhoneNumber': $phoneNumber.val()
                    }

                };
                loader.fadeIn();
                $.ajax({
                    url: '/api/hcps/enrolltoinstitution',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST',
                    headers: { __RequestVerificationToken: $frmEnrollInstitute.find('input[name=__RequestVerificationToken]').val() },
                    data: JSON.stringify(dataParams),
                    success: function (data) {
                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        loader.fadeOut();

                        toaster('Details have been saved!');

                        window.location.href = data.href;
                    },
                    error: function (error) {
                        loader.fadeOut();
                        displayErrors(error, $errorContainer );
                        adjustFooterOnWindowResize();
                    }
                }).done(function () {
                    adjustFooterOnWindowResize();
                });

            }
        // } else {
        //     //if "institution not found": undo previous values and display message
        //     undoSuggestions();
        // }
    });

    // Registration page only
    $('.js-inst-not-found').on('click', function (e){
        e.preventDefault();

        undoSuggestions();
    });

});



// Get Reults in order to populate Suggestions on the footer
let getSeachResults = function () {
    obj = {},
    searchSuggestionHtml = '';

    // Define where to display ajax errors.
    let $errorContainer = $activeSearchInput.parent().siblings('.server-errors__wrap');

    // call api
    dataParams = {
        'name': searchVal
    };

    var encodedParams = jQuery.param(dataParams);

    $.ajax({
        url: '/api/institutions?'+encodedParams, //proto
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: { __RequestVerificationToken: $antiForgeryId.val() },
        type: 'GET',
        success: function (data) {

            if(isRegisterPage && _selectedInsId.length > 0)
                _data = removeDuplicates(data);
            else
                _data = data;

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            populateSuggestions();
        },
        error: function (error) {
            displayErrors(error, $errorContainer );
        }
    }).done(function() {
        adjustFooterOnWindowResize();
    });
};

let populateSuggestions = function () {
    let $suggestionsList;

    if($('.reports__page').length)
       $suggestionsList = $activeSearchInput.closest('form').siblings('.select-institute__suggestions');
    else
        $suggestionsList = $('.select-institute__suggestions');

    if (searchVal == '') {
        searchSuggestionHtml = '';
    } else {
        for (let i = 0, l = _data.length; i < l; i++) {
            obj = {
                'id': _data[i].InstitutionId,
                'name': _data[i].InstitutionName,
                'location': _data[i].State
            };

            if (i < 10) {
                searchSuggestionHtml += searchSuggestionTmp(obj);
            }
        }
    }

    if (searchSuggestionHtml == '') {
        $suggestionsList.hide();
    } else {
        $suggestionsList.show();
    }

    $suggestionsList.html(searchSuggestionHtml);

    adjustFooterOnWindowResize();
};

let undoSuggestions = function (){
    searchVal = '';
    populateSuggestions();

    $notFoundMessage.slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false
    });
};

/* Clone markup in order to have multiple institutions */
let clone = function(){

    //set institution name
    $('.markup-to-clone')
        .find('h4')
        .text(institutionName);

    //clone and display added institution
    $('.markup-to-clone').clone(true)
        .appendTo('.list-selected-institutions')
        .attr('data-institution-id', institutionId)
        .removeClass('markup-to-clone')
        .addClass('selected-instition')
        .on('click', '.js-remove-institution', remove);

    //prepopulate the first email only with the one inserted in the home page
    if($('.selected-instition').length === 1){
        var email = $('#FirstEnrolInstitutionEmailId').val();

        $('.selected-instition .InstituteEmailAddress')
            .val(email)
            .trigger('blur')
            .parent()
            .addClass('focus');
    }

    $('.select-institute__found').show();

};

/* Remove Institution */
let remove = function(){

    let $this = $(this),
        $institutionWrap = $this.parent().parent(),
        institutionId = $institutionWrap.data('institution-id'),
        instIndex = _selectedInsId.indexOf(institutionId);

    _selectedInsId.splice(instIndex, 1);

    $institutionWrap.slideUp({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false
    });

    setTimeout(function(){
        $institutionWrap.remove();
    }, 500);

};

/* API returns a list with all the matching institutions.
** Remove selected institutions from the results */
let removeDuplicates = function(data){

    let uniqueIns = data.filter( function(institution){

        for(let i = 0, j = _selectedInsId.length; i< j ; i++){
            if(institution.InstitutionId ==  _selectedInsId[i])
                return false;
        }
        return true;
    })

    return uniqueIns;
};
